import React from "react"
import styled from "@emotion/styled"
import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const TeamBox = styled(Link)`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 300px;
    height: auto;
    background: #ffffff;
    margin: 1rem 0;
    padding: 0 0.5rem;
    padding-bottom: 4rem;
    border-radius: 2rem;
    text-align: center;
    position: relative;
    border: 1px solid ${(props) => props.theme.colors.dark_grey};

    &:hover {
        text-decoration: none !important;
        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    }
    & .image-circle {
        display: inline-block;
        position: relative;
        width: 200px;
        height: 200px;
        overflow: hidden;
        border-radius: 50%;
        margin-top: 2rem;

        & img {
            width: auto;
            height: 100%;
            transition: transform 0.5s;
        }
        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[6]}) {
            width: 175px;
            height: 175px;
        }
        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[5]}) {
            width: 150px;
            height: 150px;
        }
    }

    & p {
        margin: 2rem;
        text-align: center;
        margin: 1rem auto;
        color: ${(props) => props.theme.colors.text1};
        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[4]}) {
            font-size: 14px;
        }
    }
    & h3 {
        color: ${(props) => props.theme.colors.primary};
        margin: 0.5rem;
    }
    & .team-content {
        width: 100%;
        padding: 0 0.5rem;
        margin-top: auto;
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[3]}) {
        height: auto;
        padding-bottom: 4rem;
        margin: 1rem auto;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[2]}) {
        width: 100%;
    }
`

const Cards = ({ title, name, url, slug, imageFile }) => {
    return (
        <TeamBox to={`${url}/${slug}`}>
            <div className="image-circle">
                <GatsbyImage image={getImage(imageFile)} alt={name} />
            </div>
            <h4>{name}</h4>
            <p className="team-content">{title}</p>
        </TeamBox>
    )
}

export default Cards
